export default "__VITE_ASSET__Dv1mrYbH__"